// import { SelectOption } from '@prism/angular-shared';

export function enumToSelectOptions<T extends string>(enumObj: Record<string, T>): any[] {
    return Object.values(enumObj)
        .filter(value => typeof value === 'string') // Filter out reverse mappings
        .sort((a, b) => a.localeCompare(b)) // Alphabetical sort
        .map((value): any => ({
            value: value,
            label: value,
        }));
}